import { useState } from "react";
import {
	TextInput as RNTextInput,
	type TextInputProps as RNTextInputProps,
	Text,
} from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type Props = {
	supportingText?: string;
	showSupportingText?: boolean;
};

export type TextInputProps = RNTextInputProps & Props;

const TextInput = ({
	supportingText = "supporting text",
	showSupportingText = true,
	...props
}: TextInputProps) => {
	const [text, setText] = useState(props.value ?? "");
	const theme = useAppTheme();

	return (
		<>
			<RNTextInput
				value={text}
				onChangeText={(text) => {
					setText(text);
					props.onChangeText?.(text);
				}}
				{...props}
			/>
			<Box paddingHorizontal={16} paddingTop={4} width="100%">
				{showSupportingText && (
					<Text
						variant="bodySmall"
						style={{
							color: props.error
								? theme.colors.error
								: theme.colors.onSurfaceVariant,
						}}
					>
						{supportingText}
					</Text>
				)}
			</Box>
		</>
	);
};

export default TextInput;
